@if (showToolbar) {
  <div class="bulk-action-toolbar" [ngClass]="'bulk-action-toolbar--' + mode">
    @if (showClose) {
      <portal-icon-button
        class="bulk-action-toolbar__close-toggle"
        (onClick)="close.emit()"
        iconClass="far fa-times"
      ></portal-icon-button>
    }
    <div class="bulk-action-toolbar__main">
      <div class="bulk-action-toolbar__description">
        <span>{{
          entries.length
            | i18nPlural
              : {
                  '=0': 'bulkActions.selectEntries',
                  '=1': 'common.pagination.selected.one',
                  other: 'common.pagination.selected.many',
                }
            | portalTranslate: { count: entries.length }
        }}</span>
      </div>
      <div class="bulk-action-toolbar__actions">
        <!-- Actions -->
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}
